module.exports = __webpack_public_path__ + "media/img/scholarship_types/Scholarships For Minorities-bc5c4015d2f383526084e1255061138d.svg";